import { ClipboardCheck, Search, Send, FolderArchive } from "lucide-react";
const modulos = [{
  icon: ClipboardCheck,
  name: "Identificación KYC",
  desc: "Un flujo guiado lleva al capturista paso a paso: datos personales, documentos de identidad, verificación de domicilio y conformación del expediente. La estructura del expediente se ajusta a la fracción del Art. 17 que aplica a tu giro.",
  points: ["Captura asistida sin conocimientos legales", "Expediente conforme a las Reglas de Carácter General", "Identificación del beneficiario controlador", "OCR de INE en planes Pro y superiores"]
}, {
  icon: Search,
  name: "Screening PEP/OFAC",
  desc: "Cada cliente se coteja automáticamente contra las listas obligatorias. El resultado queda documentado con sello de tiempo, listo para presentar como evidencia ante una verificación de la autoridad.",
  points: ["Listas PEP nacionales e internacionales", "OFAC (SDN), ONU y Unión Europea", "Lista SAT Art. 69-B", "Coincidencia fonética para reducir falsos positivos"]
}, {
  icon: Send,
  name: "Avisos UIF",
  desc: "La plataforma detecta cuándo una operación supera el umbral de aviso y precarga la información requerida. Genera el reporte en el formato que exige la autoridad, evitando omisiones y errores de captura.",
  points: ["Detección automática de umbrales en UMA", "Reportes XML para SAT/UIF en planes Standard y Pro", "Calendario de cumplimiento por dígito de RFC", "Avisos normales, en ceros y de 24 horas"]
}, {
  icon: FolderArchive,
  name: "Expedientes auditables",
  desc: "Toda la documentación de soporte se centraliza en una bóveda digital cifrada, organizada cronológicamente. Cada acción queda registrada en bitácora, permitiendo responder a requerimientos en minutos.",
  points: ["Resguardo digital por 10 años (Art. 18 reformado)", "Bitácora auditable de cada acceso y acción", "Búsqueda y exportación instantánea", "Ficha KYC en PDF lista para auditoría"]
}];
export default function ModulosDetalle() {
  return <section data-section-id="REEMPLAZAR" id="modulos" className="bg-card text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 flex flex-col items-center text-center">
          <h2 className="font-default text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-5xl">
            Cuatro módulos, <span className="text-primary font-mono">un solo flujo</span>
          </h2>
          <p className="mt-4 max-w-[800px] text-lg text-slate-400 font-default">
            Cada módulo cubre una obligación de la LFPIORPI. Juntos, automatizan el ciclo completo de cumplimiento, del alta del cliente al resguardo del expediente.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 max-w-6xl mx-auto">
          {modulos.map((modulo, i) => {
          const Icon = modulo.icon;
          return <div key={modulo.name} data-index={i} className="p-6 md:p-8 rounded-lg bg-background border border-border hover:border-primary/40 transition-colors flex flex-col">
                <div className="flex items-center gap-4 mb-5">
                  <div className="size-12 rounded-md bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <Icon className="size-6 text-primary" strokeWidth={1.5} />
                  </div>
                  <h3 className="font-default text-xl font-bold text-white">{modulo.name}</h3>
                </div>
                <p className="font-default text-sm text-slate-400 leading-relaxed mb-6">
                  {modulo.desc}
                </p>
                <ul className="space-y-2.5 mt-auto">
                  {modulo.points.map((point, j) => <li key={j} className="flex items-start gap-2">
                      <span className="font-mono text-xs text-primary mt-1 flex-shrink-0">▸</span>
                      <span className="font-default text-sm text-slate-300">{point}</span>
                    </li>)}
                </ul>
              </div>;
        })}
        </div>
      </div>
    </section>;
}